import { SourceMapConsumer } from "source-map-js";
import type { RawSourceMap } from "source-map-js";

const sourceMapCache = new Map<string, SourceMapConsumer>();

async function getSourceMapConsumer(
  fileName: string,
): Promise<SourceMapConsumer | null> {
  if (sourceMapCache.has(fileName)) {
    return sourceMapCache.get(fileName)!;
  }

  try {
    const res = await fetch(`/_nuxt/${fileName}.map`, { cache: "force-cache" });
    if (!res.ok) {
      return null;
    }
    const rawMap = (await res.json()) as RawSourceMap;
    const consumer = await new SourceMapConsumer(rawMap);
    sourceMapCache[fileName] = consumer;
    return consumer;
  } catch {
    return null;
  }
}

export async function mapStackTrace(
  stack?: string,
): Promise<string | undefined> {
  if (!stack) {
    return stack;
  }

  const lines = stack.split("\n");
  const mappedLines: string[] = [];

  for (const line of lines) {
    // 예: at G (https://waresync.net/_nuxt/BzjDQRmX.js:1:3535)
    const match = line.match(/_nuxt\/([^:/]+\.js):(\d+):(\d+)/);
    if (!match) {
      mappedLines.push(line);
      continue;
    }

    const [, fileName, lineStr, columnStr] = match;
    const lineNum = parseInt(lineStr, 10);
    const columnNum = parseInt(columnStr, 10);

    const consumer = await getSourceMapConsumer(fileName);
    if (!consumer) {
      mappedLines.push(line);
      continue;
    }

    const original = consumer.originalPositionFor({
      line: lineNum,
      column: columnNum,
    });

    if (original && original.source) {
      // 원본 파일/라인으로 치환
      mappedLines.push(
        line +
          `  ==>  ${original.source}:${original.line}:${original.column} (${original.name || ""})`,
      );
    } else {
      mappedLines.push(line);
    }
  }

  return mappedLines.join("\n");
}
